import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@framework/services';


@Injectable()
export class UpdateContactService extends BaseHttpService {


    constructor(protected http: HttpClient) {
        super(http, '');
    }


   

    updateContact(payload: any) {
        const url ='/users/phone/';
        return this.post(url, payload).pipe(
            map((response: any) => {
                return response;
            }));
    }


    getContact(payload: any) {
        const url ='/users/phone/?email='+payload;
        return this.get(url, payload).pipe(
            map((response: any) => {
                return response;
            }));
    }

    CheckInviteCode(payload:any){
        const url = '/users/signup/code?='+payload;
        return this.get(url, payload).pipe(
            map((response: any) => {
                return response;
            }));
    }

    sendResetmail(payload:any){
        const url = '/users/forgot-password-phone/request/';
        return this.post(url, payload).pipe(
            map((response: any) => {
                return response;
            }));
    }

    // LOGIN
    signupCodeLogin(payload: any) {
        const url = '/users/sign-up-codes/login/';

        return this.post(url, payload).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    // GENERATE CODE
    generateSignupCode(payload: any) {

  

        const url = '/users/sign-up-codes/';

        return this.postCode(url, payload).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    // GET ALL CODES
    getSignupCodes() {
        const url = '/users/sign-up-codes/';

        return this.get(url).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    // VALIDATE CODE
    validateSignupCode(code: string) {
        const url = '/users/sign-up-codes/validate/?code='+code;

        return this.get(url).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

    validateEmail(payload: any) {
        const url = '/users/forgot-password-phone/verify/';
        
        return this.post(url, payload).pipe(
            map((response: any) => {
                return response;
            })
        );
    }

}